export default "__VITE_ASSET__xMcwXQFY__"